import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Calendar, ClipboardCheck } from 'lucide-react';

const InspectionSection = ({ vehicle, formData, setFormData, isEditing }) => {
  const [showRemarks, setShowRemarks] = useState(formData?.inspection_status === 'fail');

  const handleStatusChange = (value) => {
    setFormData({ ...formData, inspection_status: value });
    setShowRemarks(value === 'fail');
    if (value === 'pass') {
      setFormData({ 
        ...formData, 
        inspection_status: value,
        inspection_remarks: '',
        reinspection_date: ''
      });
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg flex items-center space-x-2">
          <ClipboardCheck className="h-5 w-5" />
          <span>Inspection Details</span>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {isEditing ? (
          <>
            <div>
              <Label htmlFor="inspection_date">Inspection Date</Label>
              <Input
                id="inspection_date"
                type="date"
                value={formData.inspection_date || ''}
                onChange={(e) => setFormData({...formData, inspection_date: e.target.value})}
              />
            </div>

            <div>
              <Label htmlFor="inspection_status">Status</Label>
              <Select 
                value={formData.inspection_status || 'pending'} 
                onValueChange={handleStatusChange}
              >
                <SelectTrigger>
                  <SelectValue placeholder="Select status" />
                </SelectTrigger>
                <SelectContent>
                  <SelectItem value="pending">Pending</SelectItem>
                  <SelectItem value="pass">Pass</SelectItem>
                  <SelectItem value="fail">Fail</SelectItem>
                </SelectContent>
              </Select>
            </div>

            {showRemarks && (
              <>
                <div>
                  <Label htmlFor="inspection_remarks">Remarks</Label>
                  <textarea
                    id="inspection_remarks"
                    value={formData.inspection_remarks || ''}
                    onChange={(e) => setFormData({...formData, inspection_remarks: e.target.value})}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                    rows="3"
                    placeholder="Enter inspection failure remarks..."
                  />
                </div>

                <div>
                  <Label htmlFor="reinspection_date">Re-inspection Date</Label>
                  <Input
                    id="reinspection_date"
                    type="date"
                    value={formData.reinspection_date || ''}
                    onChange={(e) => setFormData({...formData, reinspection_date: e.target.value})}
                  />
                </div>
              </>
            )}
          </>
        ) : (
          <div className="space-y-2 text-sm">
            <div className="flex justify-between">
              <span className="text-gray-600">Inspection Date:</span>
              <span className="font-medium">{vehicle?.inspection_date ? new Date(vehicle.inspection_date).toLocaleDateString() : 'Not set'}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-gray-600">Status:</span>
              <span className={`font-medium capitalize ${
                vehicle?.inspection_status === 'pass' ? 'text-green-600' : 
                vehicle?.inspection_status === 'fail' ? 'text-red-600' : 'text-yellow-600'
              }`}>
                {vehicle?.inspection_status || 'Pending'}
              </span>
            </div>
            {vehicle?.inspection_status === 'fail' && (
              <>
                <div className="flex justify-between">
                  <span className="text-gray-600">Remarks:</span>
                  <span className="font-medium text-right ml-4">{vehicle?.inspection_remarks || 'N/A'}</span>
                </div>
                <div className="flex justify-between">
                  <span className="text-gray-600">Re-inspection Date:</span>
                  <span className="font-medium">{vehicle?.reinspection_date ? new Date(vehicle.reinspection_date).toLocaleDateString() : 'Not set'}</span>
                </div>
              </>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
};

export default InspectionSection;